const addDefaultCashDeskToken_WhenByPassLogin = () => {
    if(checkByPassLogin()) {
        let token = process.env.VUE_APP_TOKEN_CASH_DESK
        localStorage.setItem('cash_desk_token', token)
    }
}

const checkByPassLogin = () => {
    return process.env.VUE_APP_BY_PASS_LOGIN === 'true'
}

export { addDefaultCashDeskToken_WhenByPassLogin }